export default __webpack_public_path__ + "assets_logo.3c746136.svg";